import cn from 'classnames';
import { HTMLAttributes } from 'react';

import HoverBounce from '../HoverBounce/HoverBounce';
import { IScrollButton, ScrollButtonSize } from './';

const spaceClasses: Record<ScrollButtonSize, string> = {
  m: 'mt-[0.3rem] mb-[0.3rem]',
  s: 'mt-1 mb-1',
};
export function ScrollButton(
  props: IScrollButton & HTMLAttributes<HTMLElement>,
) {
  const { className, children, size, ...rest } = props;

  const handleScroll = () => {
    window.scroll({
      top: window.innerHeight + (window.innerWidth >= 1024 ? 128 : 72),
      left: 0,
      behavior: 'smooth',
    });
  };

  return (
    <HoverBounce>
      <button
        {...rest}
        className={cn(
          className,
          'font-bold bg-black dark:bg-white rounded-md lg:rounded-lg justify-center flex flex-col items-center',
          'lg:py-4 lg:px-6 py-2 px-4',
        )}
        //onClick={action && doClick}
        onClick={handleScroll}
      >
        <span className={cn(spaceClasses[size], 'text-white dark:text-black')}>
          {children}
        </span>
        <span
          className={cn(spaceClasses[size], 'arrow-down dark:l-arrow d-arrow')}
        ></span>
      </button>
    </HoverBounce>
  );
}
